import { compose } from "redux";
import { connect } from "react-redux";
import { withUserData, confirmTimezone } from "../../store/user";
import { withTimestamp } from "../../store/timestamp";

export default compose(
  withUserData,
  withTimestamp,
  connect(
    () => ({}),
    dispatch => ({
      saveTimezone(timezone) {
        dispatch(confirmTimezone({ timezone, from: "route" }));
      }
    })
  )
);



// WEBPACK FOOTER //
// ./src/routes/Timezone/connected.js